import React from "react";
import NetlifyForm from "./NetlifyForm";
import FieldControl from "./FieldControl";
import SelectControl from "./SelectControl";
import SubmitControl from "./SubmitControl";

export default () => (
  <section className="container">
    <NetlifyForm
      name="provider"
      action="/providers/thankyou"
      className="lg:w-10/12 mx-auto rounded-xl p-4 sm:p-6 lg:p-8 xl:p-10 bg-navy-p3"
    >
      <div className="columns">
        <FieldControl name="name" label="Name" required={true} />
        <FieldControl name="company" label="Company" required={true} />
        <FieldControl
          name="phone"
          type="phone"
          label="Phone Number"
          required={true}
        />
        <FieldControl name="email" type="email" label="Email" required={true} />

        <FieldControl
          name="location"
          label="Location* (City & State)"
          required={true}
        />

        <SelectControl
          name="contact_preference"
          label="How would you like to be contacted?"
          required={false}
        >
          <option value="No Answer">Select</option>
          <option value="phone">Phone</option>
          <option value="email">Email</option>
        </SelectControl>

        <FieldControl
          className="w-full"
          name="hear_about_us"
          label="How did you hear about us?"
          required={false}
        />
      </div>
      <SubmitControl />
    </NetlifyForm>
  </section>
);
